
	export default {
		props: {
			paginationData: Object,
			pageNumber: Number,
			numPerPage: Number,
			sortData: Array,
			category: String,
			showPerPage: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				numItems: this.$parent.educatorid ? 6 : 8,
				page: 1,
				offset: 0,
				endPage: 3,
				updateHistory: true,
			}
		},
		watch: {
			numPerPage(n)  {
				this.updateHistory = false;
				this.numItems = n;
			},
			numItems(n) {
				if (n * this.page > this.paginationData.totalRecords) this.page = 1; 
				this.$emit("update-pagination", n, this.page, this.updateHistory);
				this.updateHistory = true;
			},
			pageNumber(p) {
				this.page = p;
			},			
			page(p) {
				// edge cases
				if (p == 1 || p == 2) this.offset = 0;
				else if (p == this.paginationData.totalPages) this.offset = this.page - 3;
				else this.offset = this.page - 2;
				this.$emit("update-pagination", this.numItems, p);
			}
		},
		computed: {
			prevBtn() {
				return this.page == 1 ? 'disabled' : '';
			},
			nextBtn() {
				return this.page == this.paginationData.totalPages ? 'disabled' : '';
			},
			paginationText() {
				if (this.page == this.paginationData.totalPages) return "Showing " + ((this.page - 1) * this.numItems + 1) + " - " + this.paginationData.totalRecords + " of " + this.paginationData.totalRecords;
				return "Showing " + ((this.page - 1) * this.numItems + 1) + " - " + (this.page * this.numItems) + " of " + this.paginationData.totalRecords;
			}
		},
		methods: {
			previous() {
				this.page -= 1;
			},
			next() {
				this.page += 1;
			},
			sendSortVal(val) {
				this.$emit("update-sort", val);
			}
		},
		created() {
			this.numItems = this.numPerPage;
		}
	}
